import { render, staticRenderFns } from "./RentJobPage.vue?vue&type=template&id=08504042&scoped=true&"
import script from "./RentJobPage.vue?vue&type=script&lang=js&"
export * from "./RentJobPage.vue?vue&type=script&lang=js&"
import style0 from "./RentJobPage.vue?vue&type=style&index=0&id=08504042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08504042",
  null
  
)

export default component.exports